import React, { useState, useEffect } from 'react';
import { Accordion, Card, Button, Modal, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { EditorState, ContentState, convertToRaw, convertFromHTML } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import DOMPurify from 'dompurify';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';


const Accordion_risposta = (props) => {

  const [valore_risposta, set_funzione_valore_risposta] = useState('');
  const [valore_domanda, set_funzione_valore_domanda] = useState('');

  const [show, setShow] = useState(false);

  useEffect(() => {

  }, []);


  const handleClose = () => {
    setShow(false);
    var lista_aux = props.lista_file_mp3
    lista_aux[props.index3].risposta = valore_risposta;
    lista_aux[props.index3].domanda = valore_domanda;
    props.funzione_set_lista_file(lista_aux)
    props.SET_aggiorna_lista(2)
  }

  const handleClose_senza_salvare = () => {
    setShow(false);
  }


  const apertura_finestra_modale = () => {
    set_funzione_valore_risposta(props.lista_file_mp3[props.index3].risposta)
    set_funzione_valore_domanda(props.lista_file_mp3[props.index3].domanda)

    setShow(true)
  }

  const handleChange_risposta = (event) => {
    set_funzione_valore_risposta(event.target.value)
  }
  const handleChange_domanda = (event) => {
    set_funzione_valore_domanda(event.target.value)
  }

  return (
    <div>
      <>
        <Button variant="primary" onClick={apertura_finestra_modale}>
          Edit
      </Button>

        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group controlId="exampleForm.ControlTextarea1">
                <Form.Label>{props.index3} + Domanda</Form.Label>
                <Form.Control as="textarea" value={valore_domanda} onChange={handleChange_domanda} rows={3} />

                <Form.Label>Risposta</Form.Label>
                <Form.Control as="textarea" value={valore_risposta} onChange={handleChange_risposta} rows={3} />
              </Form.Group>
            </Form>

          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose_senza_salvare}>
              Annulla
          </Button>
            <Button variant="primary" onClick={handleClose}>Salva</Button>
          </Modal.Footer>
        </Modal>
      </>


    </div >
  )
}
export default Accordion_risposta;